import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ecp-module-bottom',
  templateUrl: './module-bottom.component.html',
  styleUrls: ['./module-bottom.component.css']
})
export class ModuleBottomComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
